// extracted by mini-css-extract-plugin
module.exports = {"modal":"PlayerStatsModal_modal__2wbv7","content":"PlayerStatsModal_content__2Ep_B","slide-down":"PlayerStatsModal_slide-down__2PqDH","noScroll":"PlayerStatsModal_noScroll__1BU-z"};